"use client"

import { ActionTypes, useAppState } from "@/app/lib/state"
import IconClose from "@/components/global/icons/IconClose"
import IconMenu from "@/components/global/icons/IconMenu"

export default function Hamburger() {
  const { state, dispatch } = useAppState()

  return (
    <button
      className="lg:hidden"
      onClick={(e) => {
        e.preventDefault()
        dispatch({
          type: ActionTypes.SET_NAVIGATION_STATE,
          payload: { open: state.navigationState?.open ? false : true }
        })
      }}
      aria-label={state?.navigationState?.open ? "Stäng" : "Meny"}>
      {state?.navigationState?.open ? <IconClose /> : <IconMenu />}
    </button>
  )
}
